import { render, staticRenderFns } from "./FlyerSelectorController.vue?vue&type=template&id=0b6e110a&scoped=true&"
import script from "./FlyerSelectorController.vue?vue&type=script&lang=js&"
export * from "./FlyerSelectorController.vue?vue&type=script&lang=js&"
import style0 from "./FlyerSelectorController.vue?vue&type=style&index=0&id=0b6e110a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e110a",
  null
  
)

export default component.exports